export const resumeUrl = '/denzer_resume.pdf';
